import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { switchMap, EMPTY, takeUntil, Subject, skip } from 'rxjs';
import { CurrentStateService } from '../../../../core/services/current-state.service';


import { ControlPoint } from '../../../../shared/models/controlPoint';
import { Site } from '../../../../shared/models/site';
import { ControlPointsService } from '../../../control-points/services/control-points-service';
import { PopupCloseMode, PopupOpenMode } from '../../../control-points/models/popupMode';

import { UnsubscribeComponent } from '../../../../shared/components/unsubscribe/unsubscribe.component';
import { EventService } from '../../services/event-service';

import { EventData } from '../../models/event-data';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FormsModule } from '@angular/forms';
import { ApiResponse } from '../../../../shared/models/api-response';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { PositionService } from '../../../../shared/services/utilities/position.service';
import { EventPosition } from '../../models/event-position';
import { RecordHistoryComponent } from '../../../../shared/components/record-history/record-history.component';
import { VibrationsChart } from '../../../../shared/models/charts/VibrationsChart';
import { VibrationsRecordService } from '../../../../shared/services/records/vibrations-record.service';
import { LocalStorageService } from '../../../../shared/services/utilities/local-storage.service';
import { FonctionsService } from '../../../../shared/services/utilities/fonctions.service';
import { TransformedCoords } from '../../../../shared/models/transformed-coords';
import { set } from 'ol/transform';
import { ReportService, ControlPointInfoDto } from '../../../../shared/services/report/report.service';
import { ReportControlPointSelectionModalComponent, ReportGenerationParams } from '../../../report/report-control-point-selection-modal/report-control-point-selection-modal.component';
import { RecordModalComponent } from '@shared/components/record-modal/record-modal.component';

@Component({
  selector: 'app-slide-menu-event',
  imports: [CommonModule, AngularSvgIconModule, FormsModule, TranslateModule, MatDialogModule, RecordHistoryComponent],
  templateUrl: './slide-menu-event.component.html',
  styleUrl: './slide-menu-event.component.scss',
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} }
  ]
})
export class SlideMenuEventComponent
  extends UnsubscribeComponent
  implements OnInit, OnDestroy{

  @Input() toggle: boolean = false;
  @Input() currentSite: Site | undefined;
  private unsubscribe$ = new Subject<void>();
  private innerWidth: number | undefined;
  protected controlPoints: ControlPoint[] = [];
  protected subMenuVisible: boolean = false;
  protected menuVisible = true;
  protected btnCreateIsDisabled: boolean = false;
  protected lastSelectedEventIndex: number = -1;
  vibrationRecords: VibrationsChart[] = [];
  transformedCoords: TransformedCoords = { x: 0, y: 0 };
  event: EventData;
  controlPointId: number;

  siteId!: number;
  filter: string = '';
  @Input() allEvents!: EventData[];

  currentEventId: number;

  filterList() {
    if (this.filter) {
      this.filteredList = this.allEvents.filter(evt =>
        evt.name.toLowerCase().includes(this.filter.toLowerCase())
      );
    } else {
      this.filteredList = [...this.allEvents];
    }
  }


  constructor(
    protected currentStateService: CurrentStateService,
    private eventServcie: EventService,
    private router: Router,
    private positionService: PositionService,
    private recordService: VibrationsRecordService,
    private controlPointsService: ControlPointsService,
    private localStorageService: LocalStorageService,
    private dialogRecorde: MatDialog,
    private reportService: ReportService,
    private fonctionsService: FonctionsService,
    private translateService: TranslateService
  ) {
    super();
  }

  filteredList: EventData[] = [];


  protected async transformPosition(position: EventPosition): Promise<EventPosition> {
    const response = await this.positionService.transformeCoordinates(position.x, position.y, this.currentSite.epsg);
    return {
      x: response.coordX,
      y: response.coordY,
      z: position.z
    } as EventPosition;
  }


  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.currentStateService.currentSite$
      .pipe(
        switchMap((site: Site | null) => {
          this.subMenuVisible = false;
          this.lastSelectedEventIndex = -1;
          this.allEvents = [];
          this.filteredList = [];
          this.currentStateService.setCurrentEvents([]);
          if (site) {
            this.currentSite = site;
            return this.eventServcie.getVibrationEvents(site.siteId!, this.controlPointId);
          }
          return EMPTY;
        })
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (response: ApiResponse<EventData[]>) => {
          this.allEvents = this.currentStateService.setCurrentEvents(response.data);
          this.filteredList = [...this.allEvents];

        },
        error: err => {
          console.error('Error fetching vibration events:', err);
        }
      });

    // is trigger when ControlPoint is selected from list
    this.currentStateService.currentEvent$.pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (event: EventData | null) => {
        if (event) {
          const index = this.currentStateService.getCurrentEvents().findIndex(x => x.id === event.id);
          this.openCloseMenu(index);
        }
      }
    });

    this.currentStateService.currentEvents$.pipe(takeUntil(this.unsubscribe$)).subscribe(updatedList => {
      this.filteredList = updatedList;
    });

    // is trigger when popup is close
    this.currentStateService.closePopup$.pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (closeMode: PopupCloseMode | null) => {
        if (closeMode === PopupCloseMode.CREATED) {
          this.lastSelectedEventIndex = this.controlPoints.length - 1;
        }
        this.btnCreateIsDisabled = false;
      }
    });

    this.currentStateService.slideMenu$.pipe(skip(1), takeUntil(this.unsubscribe$)).subscribe({
      next: (isClose: boolean) => {
        this.menuVisible = isClose;
        this.closeAll();
      }
    });

    setTimeout(() => {
      let curentEvent = this.currentStateService.getCurrentEvent();
      if (curentEvent && this.allEvents) {
        this.lastSelectedEventIndex = this.allEvents.findIndex(x => x.id === curentEvent.id);
        this.currentStateService.setCurrentEvent(curentEvent);
        this.selectEvent(curentEvent);
      }
    }, 200);
  }

  getCurrentEvent(): EventData {
    return this.currentStateService.getCurrentEvent();
  }
  protected toggleMenu() {
    this.menuVisible = !this.menuVisible;
    this.closeAll();
  }

  private closeAll() {
    if (!this.menuVisible) {
      this.lastSelectedEventIndex = -1;
      this.subMenuVisible = false;
      this.currentStateService.setClosePopup(PopupCloseMode.CLOSE);
      this.currentStateService.setCurrentControlPoint(null);
    }
  }

  protected openEventDetail() {
    const eventId = this.currentStateService.getCurrentEvent()?.id;
    this.router.navigate(['/vibration-detail'], { queryParams: { siteId: this.currentSite?.siteId, eventId: eventId } });
  }
  protected toggleSubMenu() {
    this.closeAll();
  }

  protected openPopupCreate() {
    this.btnCreateIsDisabled = true;
    this.subMenuVisible = false;
    this.menuVisible = false;
    this.lastSelectedEventIndex = -1;
    this.currentStateService.setOpenPopup(PopupOpenMode.CREATE);
  }

  protected async selectEvent(event: EventData) {
    if(event.isHidden) return;
    this.currentStateService.setClosePopup(PopupCloseMode.CLOSE);
    this.currentStateService.setCurrentEvent(event);
    this.currentEventId = event.id;

    if (this.innerWidth && this.innerWidth < 768) {
      this.menuVisible = false;
    }

    this.event = event;

    const transformedPosition = await this.transformPosition(event.positionCoordinates);
    this.transformedCoords = {
      x: transformedPosition.x,
      y: transformedPosition.y
    };

    this.localStorageService.setItem('event-transformedCoords', this.transformedCoords);

    this.loadVibrationRecords(event.id);
    this.loadControlPoints();
  }


  protected openPopupEditPosition() {
    this.btnCreateIsDisabled = true;
    this.currentStateService.setOpenPopup(PopupOpenMode.EDIT);
  }

  protected openCloseMenu(eventIndex: number) {
    if (this.lastSelectedEventIndex == eventIndex) {
      this.lastSelectedEventIndex = -1;
      this.subMenuVisible = false;
    } else {
      this.lastSelectedEventIndex = eventIndex;

      if (!this.menuVisible) {
        this.menuVisible = true;
      }

      this.subMenuVisible = true;
    }
  }

  loadVibrationRecords(eventId: number): void {
    this.recordService.GetRecords(this.currentSite.siteId, eventId,null, null,null,null,null,false,false,false)
      .subscribe({
        next: (response) => {
          this.vibrationRecords = response.data.records;
        },
        error: (err) => {
          console.error('Error loading vibration records', err);
        }
      });
  }

  loadControlPoints(): void {
    this.controlPointsService.getControlPointsBySiteId(this.currentSite.siteId, false).subscribe({
      next: (response) => {
        this.controlPoints = response;
      },
      error: (err) => {
        console.error('Error loading control points', err);
      }
    });
  }

  downloadReport() {
    const dialogRef = this.dialogRecorde.open(ReportControlPointSelectionModalComponent, {
      width: '450px',
      disableClose: true,
      autoFocus: false,
      data: {
        siteId: this.currentSite?.siteId || this.localStorageService.getItem('currentSiteID'),
        controlPoints: this.controlPoints || [],
        eventId: this.getCurrentEvent()?.id,
        eventName: this.getCurrentEvent()?.name,
        eventType: this.getCurrentEvent()?.eventTypeLabel,
        location: undefined,
        organisation: undefined
      }
    });

    dialogRef.afterClosed().subscribe((params: ReportGenerationParams) => {
      if (params) {
        this.generateMultiRecordReport(params);
      }
    });
  }

  private generateMultiRecordReport(params: ReportGenerationParams): void {
    const controlPointsDto: ControlPointInfoDto[] = params.controlPoints.map(cp => ({
      ControlPointId: cp.ControlPointId,
      ControlPointName: cp.ControlPointName
    }));

    this.currentStateService.setReportGenerationInProgress(true);
    this.reportService.generateVibrationReport(
      undefined,
      params.startDate,
      params.endDate,
      params.ponderationId,
      params.eventName || this.getCurrentEvent()?.name,
      params.eventType || this.getCurrentEvent()?.eventTypeLabel,
      this.currentSite?.nom,
      params.organisation,
      controlPointsDto,
      this.currentSite?.siteId
    ).subscribe({
      next: (blob) => {
        this.downloadPDF(blob, `Report_MultiRecord_${new Date().toLocaleDateString('fr-FR')}.pdf`);
        this.currentStateService.setReportGenerationInProgress(false);
      },
      error: async (error) => {
        console.error('Error generating multi-record report:', error);
        const errorMessage = await this.extractErrorMessage(error);
        if (errorMessage) {
          this.fonctionsService.launch_toast(false, errorMessage);
        }
        this.currentStateService.setReportGenerationInProgress(false);
      }
    });
  }

  private downloadPDF(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  private async extractErrorMessage(error: any): Promise<string | null> {
    if (error?.error instanceof Blob) {
      try {
        const text = await error.error.text();
        const jsonError = JSON.parse(text);
        return jsonError.message || null;
      } catch (e) {
        return null;
      }
    }
    return error?.error?.message || error?.message || null;
  }

  onRecordClick(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      siteId: this.currentSite?.siteId,
      eventId: this.event.id,
      controlPointId: this.controlPointId,
      siteName: this.currentSite?.nom,
      controlPointName: null,
      regionName: this.currentSite?.region?.nom,
    };
    dialogConfig.enterAnimationDuration = '0ms';

    const dialogRef = this.dialogRecorde.open(RecordModalComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.loadVibrationRecords(this.event.id);
      }
    });
  }
  toggleVisibility(event: EventData, isHidden: boolean): void {
    const eventCopy: EventData = {
      ...event,
      isHidden: isHidden,
      positionCoordinates: null
    };
    
    this.allEvents.find(e => e.id === event.id).isHidden = isHidden;
    
    this.eventServcie.createOrUpdateVibrationEvent(this.currentSite.siteId, eventCopy, true).subscribe({
      next: () => {
        this.currentStateService.updateEventVisibility(event.id, isHidden);
      },
      error: (err: any) => {
        console.error('Error updating event visibility', err);
        this.allEvents.find(e => e.id === event.id).isHidden = !isHidden;
      }
    });
  }
  override ngOnDestroy(): void {
    this.allEvents = [];
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    super.ngOnDestroy();
  }
}
